import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useState } from "react";
import { TouchableOpacity } from "react-native";
import styled, { useTheme } from "styled-components/native";
import { ProductDetailItemProps } from "./types";

const ShowMoreItemDetail = ({
  item,
  setShowPhoneNumber,
  productColor,
}: ProductDetailItemProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();

  const [MoreNumber, setMoreNumber] = useState(true);

  const updateValue = () => {
    setShowPhoneNumber?.(true);
    setMoreNumber?.(false);
  };

  return (
    <Container>
      {MoreNumber ? (
        <>
          <TouchableOpacity onPress={() => updateValue()}>
            <RowContainer>
              <VDBText type={typography["Body-M"]} color={theme[productColor]}>
                {item?.description}
              </VDBText>
              <VDBIcon
                name={"arrow-down"}
                size={24}
                color={theme["core-04"]}
                variant={IconsVariant.VDBCustom}
              />
            </RowContainer>
          </TouchableOpacity>
          <Spacer size={SpaceType.Big} />
          <FlexMatchView>
            <MainContainerView>{<Divider />}</MainContainerView>
            <Spacer size={SpaceType.Big} />
            <MainContainerView>{<Divider />}</MainContainerView>
          </FlexMatchView>
        </>
      ) : undefined}
    </Container>
  );
};

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-04"]};
  width: 100%;
  max-width: 100%;
`;

const FlexMatchView = styled.View<any>`
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  /* margin-bottom: -30px; */
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`;

const RowContainer = styled.View<any>`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;

const Container = styled.View`
  width: 100%;
  flex: 1;
  flex-basis: auto;
`;

export default ShowMoreItemDetail;
